import classNames from 'classnames';
import { DropdownInput } from '@/_components/dropdown-input/dropdown-input';
import type { DeliveryAction } from '@/hooks/delivery/useDeliveryAction';
import { colors } from '@/Themes/Colors';
import styles from './delivery-actions-dropdown.module.scss';

interface DeliveryActionsDropdownProps {
  actions: DeliveryAction[];
  loading: boolean;
  onSelect: (action: DeliveryAction) => void;
  containerClassName?: string;
  variant?: 'outline' | 'filled';
  centerText?: boolean;
}

const VARIANT_COLORS = {
  outline: { background: colors.white, text: colors.brand10 },
  filled: { background: colors.brand10, text: colors.white },
};

export function DeliveryActionsDropdown({
  actions,
  loading,
  onSelect,
  containerClassName,
  variant = 'outline',
  centerText = variant === 'filled',
}: DeliveryActionsDropdownProps) {
  const { background, text } = VARIANT_COLORS[variant];

  return (
    <DropdownInput
      className="dropdown-action"
      options={actions}
      placeholder="Ações"
      value=""
      disableSelection
      containerClassName={classNames(styles.container, containerClassName)}
      inputStyle={{
        backgroundColor: background,
        borderColor: colors.brand10,
        color: text,
        height: '100%',
        borderWidth: 1,
      }}
      iconColor={text}
      displayValueColor={text}
      rotateIconOnOpen={variant !== 'filled'}
      displayValueStyle={centerText ? { textAlign: 'center' } : undefined}
      loading={loading}
      disabled={loading}
      onChange={value => {
        const action = actions.find(
          availableAction => availableAction.value === value,
        );

        if (action) {
          onSelect(action);
        }
      }}
    />
  );
}
